import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({

  state: {
    shopData: [],
    columnStructure: [],
    locationData: [],
    filters: [],
    ownershipLicensed: true,
    ownershipOwned: true,
    search: [],
    loading: false,
    page: 1,
    maxRows: 10,
    lastpage: 1,
    types: {},
    products: {},
    totalResults: 0
  },

  getters: {
    idColumnName: state => name => {
      var column = 0
      for (var i = 0; i < state.columnStructure.length; i++) {
        if (state.columnStructure[i].name === name) {
          column = i
        }
      }
      return column
    },
    filteredShopData: state => {
      var filteredShopdata = state.shopData
      state.filters.forEach(filter => {
        filteredShopdata = filteredShopdata.filter(record => {
          return filter.name === 'name'
            ? new RegExp(filter.value, 'i').test(record[this.idColumnName(filter.name)])
            : record[filter.name] === filter.value
        })
      })
      return filteredShopdata
    },
    ownerships: state => {
      for (var item in state.columnStructure) {
        var column = state.columnStructure[item]
        if (column.fieldName === 'ownership_type') {
          return column.cachedContents.top
        }
      }
    },
    features: state => {
      var featureData = {}
      if (!state.loading) {
        for (var item in state.columnStructure) {
          var column = state.columnStructure[item]
          if (column.fieldName.indexOf('features_') > -1) {
            var aFeatures = column.cachedContents.top
            for (var i = 0; i < aFeatures.length; i++) {
              var featureBlockList = aFeatures[i]
              var featureBlocks = featureBlockList.item.split(',')
              for (var j = 0; j < featureBlocks.length; j++) {
                var featureItem = featureBlocks[j].trim()
                if (!featureData[column.fieldName]) {
                  featureData[column.fieldName] = {
                    name: column.name,
                    items: {}
                  }
                }
                if (!featureData[column.fieldName].items[featureItem]) {
                  featureData[column.fieldName].items[featureItem] = {
                    item: featureItem,
                    count: aFeatures[i].count
                  }
                } else {
                  featureData[column.fieldName].items[featureItem].count = featureData[column.fieldName].items[featureItem].count + aFeatures[i].count
                }
              }
            }
          }
        }
      }
      return featureData
    },
    search: state => {
      return state.search
    },
    locations: state => {
      if (!state.loading) {
        return state.locationData
      } else {
        return []
      }
    },
    tablePage: state => {
      if (!state.loading) {
        var curRows = []
        for (var i = (state.page - 1) * state.maxRows; i < state.page * state.maxRows; i++) {
          if (state.locationData[i]) {
            var row = state.locationData[i]
            curRows.push({id: row.id, name: row.name, address: row.address, place: row.place, state: row.state, type: row.type, products: row.products_string, services: row.services_string})
          }
        }
        return curRows
      } else {
        return []
      }
    },
    paging: state => {
      if (!state.loading) {
        return [
          {page: 1, label: '‹ first'},
          {page: (state.page > 2) ? state.page - 1 : 1, label: '« prev'},
          {page: state.page, label: state.page},
          {page: (parseInt(state.page) + 2 <= state.lastpage) ? parseInt(state.page) + 1 : state.lastpage, label: 'next »'},
          {page: state.lastpage, label: 'last ›'}
        ]
      } else {
        return []
      }
    },
    productsBar: state => {
      if (!state.loading) {
        var iTotal = state.totalResults
        var oProducts = {}
        for (var oProduct in state.products) {
          oProducts[oProduct] = {
            name: oProduct,
            count: state.products[oProduct],
            percentage: parseInt(state.products[oProduct] * 100 / iTotal)
          }
        }
        return oProducts
      } else {
        return {}
      }
    },
    typesBar: state => {
      if (!state.loading) {
        var iTotal = state.totalResults
        var oTypes = {}
        for (var oType in state.types) {
          oTypes[oType] = {
            name: oType,
            count: state.types[oType],
            percentage: parseInt(state.types[oType] * 100 / iTotal)
          }
        }
        return oTypes
      } else {
        return {}
      }
    }
  },

  mutations: {
    SET_SHOPDATA (state, shopData) {
      state.shopData = shopData
    },
    SET_COLUMN_STRUCTURE (state, columnStructure) {
      state.columnStructure = columnStructure
    },
    ADD_FILTER (state, filters) {
      if (filters.type === 'ownership') {
        if (filters.filters.length > 0) {
          state.ownershipLicensed = false
          state.ownershipOwned = false
          for (var ownership in filters.filters) {
            if (filters.filters[ownership] === 'Licensed') {
              state.ownershipLicensed = true
            } else {
              state.ownershipOwned = true
            }
          }
        } else {
          state.ownershipLicensed = true
          state.ownershipOwned = true
        }
      } else {
        state.filters = []
        for (var filter in filters.filters) {
          state.filters.push(filters.filters[filter])
        }
      }
      this.dispatch('renderLocationData')
    },
    REMOVE_FILTER (state, filter) {
      var i = state.filters.length
      while (i--) {
        if (state.filters[i] === filter) {
          state.filters.splice(i, 1)
        }
      }
    },
    CLEAR_FILTERS (state) {
      state.filters = []
      this.dispatch('renderLocationData')
    },
    SET_PAGE (state, page) {
      state.page = page
    },
    SET_LOADING (state, loading) {
      state.loading = loading
    },
    ADD_SEARCH (state, search) {
      state.search.push(search)
      this.dispatch('renderLocationData')
    },
    REMOVE_SEARCH (state, search) {
      for (var q = state.search.length - 1; q >= 0; q--) {
        if (state.search[q] === search) {
          state.search.splice(q, 1)
        }
      }
      this.dispatch('renderLocationData')
    },
    SET_TYPES (state, types) {
      state.types = types
    },
    SET_PRODUCTS (state, products) {
      state.products = products
    },
    SET_LOCATIONS (state, shopData) {
      var results = []
      var totalcount = 0
      var sTypes = {}
      var sProducts = {}
      for (var sb in state.shopData) {
        var record = state.shopData[sb]
        var filters = state.filters
        var matchesFilters = true
        for (var i = 0; i < filters.length; i++) {
          var sFilter = filters[i]
          if ((record[13] === null || record[13].indexOf(sFilter) === -1) && (record[14] === null || record[14].indexOf(sFilter) === -1) && (record[10] === null || record[10].indexOf(sFilter) === -1) && (record[19] === null || record[19].indexOf(sFilter) === -1)) {
            matchesFilters = false
          }
        }
        if (record[11] === 'Licensed') {
          if (state.ownershipLicensed === false) {
            matchesFilters = false
          }
        } else {
          if (state.ownershipOwned === false) {
            matchesFilters = false
          }
        }
        if (state.search.length) {
          for (var p = 0; p < state.search.length; p++) {
            var sSearch = state.search[p]
            if ((record[13] === null || record[13].indexOf(sSearch) === -1) && (record[14] === null || record[14].indexOf(sSearch) === -1) && (record[10] === null || record[10].indexOf(sSearch) === -1) && (record[19] === null || record[19].indexOf(sSearch) === -1)) {
              matchesFilters = false
            }
          }
        }
        if (matchesFilters) {
          totalcount++
          var curType = record[11]
          if (sTypes[curType]) {
            sTypes[curType] = sTypes[curType] + 1
          } else {
            sTypes[curType] = 1
          }
          var aProducts = (record[13] != null) ? record[13].split(',').map(function (item) { return item.trim() }) : []
          for (var j = 0; j < aProducts.length; j++) {
            var curProduct = aProducts[j]
            if (sProducts[curProduct]) {
              sProducts[curProduct] = sProducts[curProduct] + 1
            } else {
              sProducts[curProduct] = 1
            }
          }
          results.push({
            id: record[0],
            text: ['<strong>' + record[8] + ' - ' + record[10] + '</strong>', '<br>', record[20], '<br>', record[23], record[24], '<br><br>', 'Products: ', (record[13] != null) ? record[13] : ' - ', '<br>', 'Services: ', (record[14] != null) ? record[14] : ' - ', '<br><br>', '<em>' + record[11] + '</em>'].join(' '),
            name: record[8] + ' - ' + record[10],
            address: record[20],
            place: record[23],
            state: record[24],
            type: curType,
            products: aProducts,
            services: (record[14] != null) ? record[14].split(',').map(function (item) { return item.trim() }) : [],
            products_string: (record[13] != null) ? record[13] : '',
            services_string: (record[14] != null) ? record[14] : '',
            lat: record[28],
            lng: record[29]
          })
        }
      }
      state.totalResults = totalcount
      state.lastpage = parseInt(totalcount / state.maxRows) + 1
      state.locationData = results
      state.types = sTypes
      state.products = sProducts
    }
  },

  actions: {
    loadShopData ({ commit }) {
      commit('SET_LOADING', true)
      var request = new XMLHttpRequest()
      request.open('GET', 'static/rows.json', true)
      request.onload = function () {
        if (request.status >= 200 && request.status < 400) {
          var resultJson = JSON.parse(request.responseText)
          commit('SET_SHOPDATA', resultJson.data)
          commit('SET_LOCATIONS', resultJson.data)
          commit('SET_COLUMN_STRUCTURE', resultJson.meta.view.columns)
        } else {
          console.log('that went wrong')
        }
        commit('SET_LOADING', false)
      }
      request.onerror = function () {
        console.log('that went wrong too')
      }
      request.send()
    },

    renderLocationData ({ commit, state }) {
      commit('SET_LOCATIONS', state.shopData)
    },

    addFilter ({ commit, state }) {
      // WHERE DO WE GET FILTER?
      commit('ADD_FILTER', state)
    },

    removeFilter ({ commit, state }) {
      // WHERE DO WE GET FILTER?
      commit('REMOVE_FILTER', state)
    },

    clearFilters ({ commit }) {
      commit('CLEAR_FILTERS')
    }

  }
})



// WEBPACK FOOTER //
// ./src/store/index.js